import Resume from "pages/resume";

export default function ResumePage() {
  return <Resume />;
}